import {
	Address,
	BusinessContact,
	createResource,
	ErrorDocument,
	EvaluationScores,
	FullName,
	getFile,
	getResource,
	IpLocationDetails,
	OkDocument,
	Permissible,
	Phone,
	PhoneLocationDetails,
	Resource,
	RiskRate,
	updateResource,
	uploadResource,
	apiUrl,
} from "./common"
import {post} from "../utilities/http"
import {err, ok, Result} from "neverthrow"
import moment from "moment"
import {BeneficialOwner, BeneficialOwnerResource} from "./beneficialOwner"
import {IcomoonIconName} from "../components/Icon/icons"
import {v4 as uuidv4} from "uuid"
import {ReevaluatedBeneficialOwnerApplicationData} from "../components/ReevaluateApplication/Forms/ReevaluateBeneficialOwnerForm/ReevaluateBeneficialOwnerForm"
import {ReevaluatedOfficerApplicationData} from "../components/ReevaluateApplication/Forms/ReevaluateOfficerForm/ReevaluateOfficerForm"
import {ReevaluatedBusinessApplicationDataRequest} from "../components/ReevaluateApplication/Forms/ReevaluateBusinessForm/ReevaluateBusinessForm"
import {
	AddressVerificationDocumentFormValues,
	BusinessAddressVerificationDocumentFormValues,
	CertificateOfIncorporationDocumentFormValues,
	EmployerIdentificationNumberConfirmationDocumentFormValues,
	IdDocumentFormValues,
	MatriculaConsularDocumentFormValues,
	PassportDocumentFormValues,
	SelfieVerificationDocumentFormValues,
	SSNDocumentFormValues,
} from "../components/ApplicationDocuments/EditDocument/Forms/types"

export enum EvaluationOutcome {
	Approved = "Approved",
	Denied = "Denied",
	Pending = "Pending",
	PendingReview = "PendingReview",
}

export enum Occupation {
	ArchitectOrEngineer = "Architect or Engineer",
	BusinessAnalystAccountantOrFinancialAdvisor = "Business Analyst Accountant or Financial Advisor",
	CommunityAndSocialServicesWorker = "Community And Social Services Worker",
	ConstructionMechanicOrMaintenanceWorker = "Construction Mechanic or Maintenance Worker",
	Doctor = "Doctor",
	Educator = "Educator",
	EntertainmentSportsArtsOrMedia = "Entertainment Sports Arts or Media",
	ExecutiveOrManager = "Executive or Manager",
	FarmerFishermanForester = "Farmer Fisherman Forester",
	FoodServiceWorker = "Food Service Worker",
	GigWorker = "Gig Worker",
	HospitalityOfficeOrAdministrativeSupportWorker = "Hospitality Office or Administrative Support Worker",
	HouseholdManager = "Household Manager",
	JanitorHousekeeperLandscaper = "Janitor Housekeeper Landscaper",
	Lawyer = "Lawyer",
	ManufacturingOrProductionWorker = "Manufacturing or Production Worker",
	MilitaryOrPublicSafety = "Military or Public Safety",
	NurseHealthcareTechnicianOrHealthcareSupport = "Nurse Healthcare Technician or Healthcare Support",
	PersonalCareOrServiceWorker = "Personal Care or Service Worker",
	PilotDriverOperator = "Pilot Driver Operator",
	SalesRepresentativeBrokerAgent = "Sales Representative Broker Agent",
	ScientistOrTechnologist = "Scientist or Technologist",
	Student = "Student",
}

export const OccupationMapping = new Map(Object.entries(Occupation))

export enum OfficerTitle {
	President = "President",
	CEO = "CEO",
	COO = "COO",
	CFO = "CFO",
	BenefitsAdministrationOfficer = "BenefitsAdministrationOfficer",
	CIO = "CIO",
	VP = "VP",
	AVP = "AVP",
	Treasurer = "Treasurer",
	Secretary = "Secretary",
	Controller = "Controller",
	Manager = "Manager",
	Partner = "Partner",
	Member = "Member",
}

export const OfficerTitleMapping = new Map(Object.entries(OfficerTitle))

export enum AnnualIncome {
	UpTo10k = "Up to 10k",
	Between10kAnd25k = "Between 10k and 25k",
	Between25kAnd50k = "Between 25k and 50k",
	Between50kAnd100k = "Between 50k and 100k",
	Between100kAnd250k = "Between 100k and 250k",
	Over250k = "Over 250k",
}

export const AnnualIncomeMapping = new Map(Object.entries(AnnualIncome))

export enum BusinessAnnualRevenue {
	UpTo250k = "Up to 250K",
	Between250kAnd500k = "Between 250K and 500K",
	Between500kAnd1m = "Between 500K and 1M",
	Between1mAnd5m = "Between 1M and 5M",
	Over5m = "Over 5M",
}

export const BusinessAnnualRevenueMapping = new Map(Object.entries(BusinessAnnualRevenue))

export enum SoleProprietorshipAnnualRevenue {
	UpTo50k = "Up to 50K",
	Between50kAnd100k = "Between 50K and 100K",
	Between100kAnd200k = "Between 100K and 200K",
	Between200kAnd500k = "Between 200K and 500K",
	Over500k = "Over 500K",
}

export const SoleProprietorshipAnnualRevenueMapping = new Map(Object.entries(SoleProprietorshipAnnualRevenue))

export enum SoleProprietorshipNumberOfEmployees {
	One = "1",
	Between2And5 = "Between 2 and 5",
	Between5And10 = "Between 5 and 10",
	Over10 = "Over 10",
}

export const SoleProprietorshipNumberOfEmployeesMapping = new Map(Object.entries(SoleProprietorshipNumberOfEmployees))

export enum BusinessNumberOfEmployees {
	UpTo10 = "Up to 10",
	Between10And50 = "Between 10 and 50",
	Between50And100 = "Between 50 and 100",
	Between100And500 = "Between 100 and 500",
	Over500 = "Over 500",
}

export const BusinessNumberOfEmployeesMapping = new Map(Object.entries(BusinessNumberOfEmployees))

export enum BusinessVertical {
	AdultEntertainmentDatingOrEscortServices = "Adult Entertainment Dating or Escort Services",
	AdvertisingOrMarketing = "Advertising or Marketing",
	AgricultureForestryFishingOrHunting = "Agriculture Forestry Fishing or Hunting",
	ArtsEntertainmentAndRecreation = "Arts Entertainment and Recreation",
	BusinessSupportOrBuildingServices = "Business Support or Building Services",
	Cannabis = "Cannabis",
	Construction = "Construction",
	DirectMarketingOrTelemarketing = "Direct Marketing or Telemarketing",
	EducationalServices = "Educational Services",
	FinancialServicesCryptocurrency = "Financial Services Cryptocurrency",
	FinancialServicesDebitCollectionOrConsolidation = "Financial Services Debit Collection or Consolidation",
	FinancialServicesMoneyServicesBusinessOrCurrencyExchange = "Financial Services Money Services Business or Currency Exchange",
	FinancialServicesOther = "Financial Services Other",
	FinancialServicesPaydayLending = "Financial Services Payday Lending",
	GamingOrGambling = "Gaming or Gambling",
	HealthCareAndSocialAssistance = "Health Care and Social Assistance",
	HospitalityAccommodationOrFoodServices = "Hospitality Accommodation or Food Services",
	LegalAccountingConsultingOrComputerProgramming = "Legal Accounting Consulting or Computer Programming",
	Manufacturing = "Manufacturing",
	Mining = "Mining",
	Nutraceuticals = "Nutraceuticals",
	PersonalCareServices = "Personal Care Services",
	PublicAdministration = "Public Administration",
	RealEstate = "Real Estate",
	ReligiousCivicAndSocialOrganizations = "Religious Civic and Social Organizations",
	RepairAndMaintenance = "Repair and Maintenance",
	RetailTrade = "Retail Trade",
	TechnologyMediaOrTelecom = "Technology Media or Telecom",
	TransportationOrWarehousing = "Transportation or Warehousing",
	Utilities = "Utilities",
	WholesaleTrade = "Wholesale Trade",
}

export const BusinessVerticalMapping = new Map(Object.entries(BusinessVertical))

export enum CashFlow {
	Predictable = "Predictable",
	Unpredictable = "Unpredictable",
}

export const CashFlowMapping = new Map(Object.entries(CashFlow))

export enum SourceOfIncome {
	EmploymentOrPayrollIncome = "Employment or Payroll Income",
	PartTimeOrContractorIncome = "Part Time or Contractor Income",
	InheritancesAndGifts = "Inheritances and Gifts",
	PersonalInvestments = "Personal Investments",
	BusinessOwnershipInterests = "Business Ownership Interests",
	GovernmentBenefits = "Government Benefits",
}

export const SourceOfIncomeMapping = new Map(Object.entries(SourceOfIncome))

export enum BusinessIndustry {
	// Retail
	GroceryStoresOrSupermarkets = "Grocery Stores or Supermarkets",
	ConvenienceStores = "Convenience Stores",
	SpecialtyFoodRetailers = "Specialty Food Retailers",
	GasStationsWithRetail = "Gas Stations with Retail",
	GeneralMerchandiseOrDepartmentStores = "General Merchandise or Department Stores",
	OnlineRetailOrECommerce = "Online Retail or E-Commerce",
	SubscriptionAndMembershipPlatforms = "Subscription and Membership Platforms",
	DirectToConsumerBrands = "Direct to Consumer Brands",
	Cannabis = "Cannabis",
	// Financial Services
	BanksOrCreditUnions = "Banks or Credit Unions",
	FinTechOrPaymentProcessing = "FinTech or Payment Processing",
	InsuranceProviders = "Insurance Providers",
	InvestmentAdvisorsOrBrokerDealers = "Investment Advisors or Broker Dealers",
	LendingOrMortgageCompanies = "Lending or Mortgage Companies",
	TreasuryManagementPlatforms = "Treasury Management Platforms",
	PersonalFinanceAppsOrAIAssistants = "Personal Finance Apps or AI Assistants",
	RetirementPlanning = "Retirement Planning",
	RealEstateInvestmentPlatforms = "Real Estate Investment Platforms",
	MoneyServiceBusinesses = "Money Service Businesses",
	Cryptocurrency = "Cryptocurrency",
	DebtCollection = "Debt Collection",
	PaydayLending = "Payday Lending",
	Gambling = "Gambling",
	// Food & Agriculture
	FarmsOrAgriculturalProducers = "Farms or Agricultural Producers",
	FoodWholesalersOrDistributors = "Food Wholesalers or Distributors",
	RestaurantsOrCafes = "Restaurants or Cafes",
	BarsOrNightclubs = "Bars or Nightclubs",
	CateringServices = "Catering Services",
	FarmersMarkets = "Farmers Markets",
	RestaurantTechAndPOSProviders = "Restaurant Tech and POS Providers",
	// Healthcare
	HospitalsOrClinics = "Hospitals or Clinics",
	Pharmacies = "Pharmacies",
	MedicalEquipmentSuppliers = "Medical Equipment Suppliers",
	BiotechnologyFirms = "Biotechnology Firms",
	HomeHealthServices = "Home Health Services",
	HealthcareStaffingPlatforms = "Healthcare Staffing Platforms",
	WellnessAndBenefitsPlatforms = "Wellness and Benefits Platforms",
	HealthcareAndSocialAssistance = "Healthcare and Social Assistance",
	// Professional Services
	LegalServices = "Legal Services",
	AccountingOrAuditingFirms = "Accounting or Auditing Firms",
	ConsultingFirms = "Consulting Firms",
	MarketingOrAdvertisingAgencies = "Marketing or Advertising Agencies",
	RealEstateAgentsOrPropertyManagers = "Real Estate Agents or Property Managers",
	CorporateServicesAndIncorporation = "Corporate Services and Incorporation",
	HRAndWorkforceManagementPlatforms = "HR and Workforce Management Platforms",
	DirectMarketingOrTelemarketing = "Direct Marketing or Telemarketing",
	LegalAccountingConsultingOrComputerProgramming = "Legal Accounting Consulting or Computer Programming",
	// Manufacturing
	ChemicalManufacturing = "Chemical Manufacturing",
	ElectronicsOrHardwareManufacturing = "Electronics or Hardware Manufacturing",
	AutomotiveManufacturing = "Automotive Manufacturing",
	ConstructionMaterials = "Construction Materials",
	TextilesOrApparel = "Textiles or Apparel",
	Mining = "Mining",
	// Real Estate & Construction
	RealEstate = "Real Estate",
	Construction = "Construction",
	// Other
	TransportationOrWarehousing = "Transportation or Warehousing",
	WholesaleTrade = "Wholesale Trade",
	BusinessSupportOrBuildingServices = "Business Support or Building Services",
	EscortServices = "Escort Services",
	DatingOrAdultEntertainment = "Dating or Adult Entertainment",
}

export const BusinessIndustryMapping = new Map(Object.entries(BusinessIndustry))

export enum BusinessSourceOfFunds {
	SalesOfGoods = "Sales of Goods",
	SalesOfServices = "Sales of Services",
	CustomerPayments = "Customer Payments",
	InvestmentCapital = "Investment Capital",
	BusinessLoans = "Business Loans",
	OwnerContributions = "Owner Contributions",
	FranchiseRevenue = "Franchise Revenue",
	RentalIncome = "Rental Income",
	GovernmentContractsOrGrants = "Government Contracts or Grants",
	DonationsOrFundraising = "Donations or Fundraising",
	MembershipFeesOrSubscriptions = "Membership Fees or Subscriptions",
	LicensingOrRoyalties = "Licensing or Royalties",
	CommissionIncome = "Commission Income",
	ImportExportRevenue = "Import Export Revenue",
	CryptocurrencyRelatedActivity = "Cryptocurrency Related Activity",
}

export const BusinessSourceOfFundsMapping = new Map(Object.entries(BusinessSourceOfFunds))

export enum BusinessAccountPurpose {
	RetailSalesInPerson = "Retail Sales In Person",
	EcommerceSales = "Ecommerce Sales",
	CashHeavyIncomeAndOperations = "Cash Heavy Income and Operations",
	ImportExportTradeOperations = "Import Export Trade Operations",
	ProfessionalServicesNotHandlingFunds = "Professional Services Not Handling Funds",
	ProfessionalServicesHandlingFunds = "Professional Services Handling Funds",
	HoldingOrInvestmentCompanyOperations = "Holding or Investment Company Operations",
	PropertyManagementOrRealEstateOperations = "Property Management or Real Estate Operations",
	CharitableOrNonProfitOrganizationOperations = "Charitable or Non Profit Organization Operations",
	ConstructionAndContractingOperations = "Construction and Contracting Operations",
	CommercialCashOperations = "Commercial Cash Operations",
	FreightForwardingOrLogisticsOperations = "Freight Forwarding or Logistics Operations",
	ThirdPartyPaymentProcessing = "Third Party Payment Processing",
	TechnologyStartupOperations = "Technology Startup Operations",
	WholesaleDistributionOperations = "Wholesale Distribution Operations",
	FranchiseOperationOperations = "Franchise Operation Operations",
	HealthcareProviderOperations = "Healthcare Provider Operations",
	EducationalInstitutionOperations = "Educational Institution Operations",
}

export const BusinessAccountPurposeMapping = new Map(Object.entries(BusinessAccountPurpose))

export enum BusinessTransactionVolume {
	LessThan10K = "Less than 10K",
	Between10KAnd50K = "Between 10K and 50K",
	Between50KAnd250K = "Between 50K and 250K",
	Between250KAnd1M = "Between 250K and 1M",
	Between1MAnd2M = "Between 1M and 2M",
	GreaterThan2M = "Greater than 2M",
}

export const BusinessTransactionVolumeMapping = new Map(Object.entries(BusinessTransactionVolume))

export enum UsNexusType {
	NotAvailable = "Not Available",
	BankingRelationships = "Banking Relationships",
	Customers = "Customers",
	Employees = "Employees",
	PhysicalOfficeOrFacility = "Physical Office or Facility",
}

export const AvailableUsNexusTypes = [
	UsNexusType.BankingRelationships,
	UsNexusType.Customers,
	UsNexusType.Employees,
	UsNexusType.PhysicalOfficeOrFacility,
]

export const UsNexusTypeMapping = new Map(Object.entries(UsNexusType).filter(([key]) => key !== "NotAvailable"))

export enum IndividualSourceOfFunds {
	SalaryOrWages = "Salary or Wages",
	BusinessIncome = "Business Income",
	InvestmentIncome = "Investment Income",
	RetirementSavings = "Retirement Savings",
	Inheritance = "Inheritance",
	Gift = "Gift",
	SaleOfAssets = "Sale of Assets",
	LegalSettlement = "Legal Settlement",
	LoanProceeds = "Loan Proceeds",
}

export const IndividualSourceOfFundsMapping = new Map(Object.entries(IndividualSourceOfFunds))

export enum IndividualAccountPurpose {
	PayrollOrDirectDeposit = "Payroll or Direct Deposit",
	PersonalSavingsOrEmergencyFund = "Personal Savings or Emergency Fund",
	EverydaySpending = "Everyday Spending",
	DomesticP2PAndBillPay = "Domestic P2P and Bill Pay",
	InternationalRemittances = "International Remittances",
	CashHeavyPersonalIncome = "Cash Heavy Personal Income",
	PropertyPurchaseOrInvestment = "Property Purchase or Investment",
	EducationOrStudentUse = "Education or Student Use",
	TrustOrEstateDistributions = "Trust or Estate Distributions",
	Cryptocurrency = "Cryptocurrency",
}

export const IndividualAccountPurposeMapping = new Map(Object.entries(IndividualAccountPurpose))

export enum IndividualTransactionVolume {
	LessThan1K = "Less than 1K",
	Between1KAnd5K = "Between 1K and 5K",
	Between5KAnd15K = "Between 5K and 15K",
	Between15KAnd30K = "Between 15K and 30K",
	Between30KAnd60K = "Between 30K and 60K",
	GreaterThan60K = "Greater than 60K",
}

export const IndividualTransactionVolumeMapping = new Map(Object.entries(IndividualTransactionVolume))

export enum SolePropTransactionVolume {
	LessThan5K = "Less than 5K",
	Between5KAnd20K = "Between 5K and 20K",
	Between20KAnd75K = "Between 20K and 75K",
	Between75KAnd150K = "Between 75K and 150K",
	Between150KAnd300K = "Between 150K and 300K",
	GreaterThan300K = "Greater than 300K",
}

export const SolePropTransactionVolumeMapping = new Map(Object.entries(SolePropTransactionVolume))

export enum Profession {
	Accountant = "Accountant",
	Actor = "Actor",
	Administrator = "Administrator",
	Analyst = "Analyst",
	Architect = "Architect",
	Artist = "Artist",
	Attorney = "Attorney",
	Auditor = "Auditor",
	Banker = "Banker",
	Barber = "Barber",
	Bartender = "Bartender",
	Bookkeeper = "Bookkeeper",
	Broker = "Broker",
	BusinessOwner = "Business Owner",
	Chef = "Chef",
	Clergy = "Clergy",
	Coach = "Coach",
	Consultant = "Consultant",
	Contractor = "Contractor",
	CustomerServiceRepresentative = "Customer Service Representative",
	Dentist = "Dentist",
	Designer = "Designer",
	Developer = "Developer",
	Doctor = "Doctor",
	Driver = "Driver",
	Economist = "Economist",
	Educator = "Educator",
	Electrician = "Electrician",
	Engineer = "Engineer",
	Entrepreneur = "Entrepreneur",
	EventPlanner = "Event Planner",
	Executive = "Executive",
	Farmer = "Farmer",
	FinancialAdvisor = "Financial Advisor",
	Firefighter = "Firefighter",
	Fisherman = "Fisherman",
	FlightAttendant = "Flight Attendant",
	Freelancer = "Freelancer",
	GovernmentEmployee = "Government Employee",
	GraphicDesigner = "Graphic Designer",
	HealthcareWorker = "Healthcare Worker",
	HRProfessional = "HR Professional",
	InsuranceAgent = "Insurance Agent",
	Investor = "Investor",
	ITSpecialist = "IT Specialist",
	Janitor = "Janitor",
	Journalist = "Journalist",
	Laborer = "Laborer",
	LawEnforcementOfficer = "Law Enforcement Officer",
	Lawyer = "Lawyer",
	Librarian = "Librarian",
	LogisticsCoordinator = "Logistics Coordinator",
	Manager = "Manager",
	MarketingProfessional = "Marketing Professional",
	Mechanic = "Mechanic",
	MilitaryPersonnel = "Military Personnel",
	Musician = "Musician",
	Nurse = "Nurse",
	Optometrist = "Optometrist",
	Painter = "Painter",
	Pharmacist = "Pharmacist",
	Photographer = "Photographer",
	PhysicalTherapist = "Physical Therapist",
	Pilot = "Pilot",
	Plumber = "Plumber",
	PoliceOfficer = "Police Officer",
	Professor = "Professor",
	Programmer = "Programmer",
	ProjectManager = "Project Manager",
	RealEstateAgent = "Real Estate Agent",
	Receptionist = "Receptionist",
	Researcher = "Researcher",
	RetailWorker = "Retail Worker",
	Salesperson = "Salesperson",
	Scientist = "Scientist",
	SocialWorker = "Social Worker",
	SoftwareEngineer = "Software Engineer",
	Student = "Student",
	Surgeon = "Surgeon",
	Teacher = "Teacher",
	Technician = "Technician",
	Therapist = "Therapist",
	Trainer = "Trainer",
	Veterinarian = "Veterinarian",
	WaiterWaitress = "Waiter/Waitress",
	Writer = "Writer",
}

export const ProfessionMapping = new Map(Object.entries(Profession))

export enum ApplicationDocumentType {
	addressVerification = "AddressVerification",
	idDocument = "IdDocument",
	passport = "Passport",
	socialSecurityCard = "SocialSecurityCard",
	certificateOfIncorporation = "CertificateOfIncorporation",
	employerIdentificationNumberConfirmation = "EmployerIdentificationNumberConfirmation",
	powerOfAttorney = "PowerOfAttorney",
	clientRequested = "ClientRequested",
	selfieVerification = "SelfieVerification",
	matriculaConsular = "MatriculaConsularCard",
}

export const backSupportedDocumentTypes = [
	ApplicationDocumentType.idDocument,
	ApplicationDocumentType.selfieVerification,
]

export type DocumentLink = {
	type: string
	attributes: {
		link: string
		contentType: string
	}
}

export enum IndustryType {
	Retail = "Retail",
	Wholesale = "Wholesale",
	Restaurants = "Restaurants",
	Hospitals = "Hospitals",
	Construction = "Construction",
	Insurance = "Insurance",
	Unions = "Unions",
	RealEstate = "RealEstate",
	FreelanceProfessional = "FreelanceProfessional",
	OtherProfessionalServices = "OtherProfessionalServices",
	OnlineRetailer = "OnlineRetailer",
	OtherEducationServices = "OtherEducationServices",
}

export const IndustryMapping = new Map(Object.entries(IndustryType))

export enum CustomerDueDiligence {
	Default = "Default",
	Version2026v1 = "2026.v1",
}

export const CustomerDueDiligenceMapping = new Map(Object.entries(CustomerDueDiligence))

export type Officer = {
	fullName: FullName
	ssn: Permissible<string>
	passport: Permissible<string>
	nationality: Permissible<string>
	matriculaConsular: Permissible<string>
	address: Permissible<Address>
	dateOfBirth: Permissible<Date>
	email: Permissible<string>
	phone: Permissible<Phone>
	status: EvaluationOutcome
	title?: OfficerTitle
	evaluationFlags?: string[]
	maskedSSN?: string
	maskedPassport?: string
	maskedMatriculaConsular?: string
	idTheftScore?: number
	evaluationCodes?: string[]
	occupation?: Occupation
	sourceOfIncome?: SourceOfIncome
	annualIncome?: AnnualIncome
	evaluation?: PersonExternalEvaluation
	evaluationId?: string
}

export enum ApplicationDocumentStatus {
	Required = "Required",
	ReceivedBack = "ReceivedBack",
	ReceivedFront = "ReceivedFront",
	Invalid = "Invalid",
	Approved = "Approved",
	PendingReview = "PendingReview",
}

export enum PatchApplicationDocumentType {
	EmployerIdentificationNumberConfirmation = "employerIdentificationNumberConfirmation",
	CertificateOfIncorporation = "certificateOfIncorporation",
	AddressVerification = "addressVerification",
	SocialSecurityCard = "socialSecurityCard",
	IdDocument = "idDocument",
	MatriculaConsular = "matriculaConsularCard",
	Passport = "passport",
	SelfieVerification = "selfieVerification",
}

export type DocumentFormValues =
	| PassportDocumentFormValues
	| IdDocumentFormValues
	| SSNDocumentFormValues
	| MatriculaConsularDocumentFormValues
	| AddressVerificationDocumentFormValues
	| BusinessAddressVerificationDocumentFormValues
	| CertificateOfIncorporationDocumentFormValues
	| EmployerIdentificationNumberConfirmationDocumentFormValues
	| SelfieVerificationDocumentFormValues

export type DocumentFormValuesRequestIdempotencyKey = DocumentFormValues & {
	idempotencyKey: string
}

export type PatchApplicationDocument = {
	type: PatchApplicationDocumentType
	attributes: DocumentFormValuesRequestIdempotencyKey
}

export type PatchProductApplicationDocument = {
	type: PatchApplicationDocumentType
	attributes: DocumentFormValuesRequestIdempotencyKey
	relationships: {
		productApplication: {
			data: {
				type: "productApplication"
				id: string
			}
		}
	}
}

export type ApplicationDocumentRelationship =
	| ApplicationRelationship
	| (OfficerRelationship & BeneficialOwnerRelationship)
	| OfficerRelationship
	| BeneficialOwnerRelationship

export type DocumentEvaluationFlag = {
	messageCode?: string
	description: string
}

export function documentEvaluationFlagDescriptions(flags?: DocumentEvaluationFlag[]): string[] {
	if (!flags) return []
	return flags.map((flag) => flag.description)
}

export type ApplicationDocument = {
	type: "document"
	id: string
	attributes: {
		documentType: ApplicationDocumentType
		status: ApplicationDocumentStatus
		passport: string
		matriculaConsular: string
		ssn: string
		nationality: string
		name: string
		fullName?: FullName
		businessName?: string
		address: Permissible<Address>
		dateOfIncorporation: Date
		ein: string
		dateOfBirth: Date
		frontDocumentId?: string
		frontDocumentStoreId?: string
		backDocumentId?: string
		backDocumentStoreId?: string
		additionalDocumentId?: string
		additionalDocumentStoreId?: string
		evaluationId?: string
		evaluationFlags?: DocumentEvaluationFlag[]
		reason?: string
		reasonCode?: string
		updatedAt?: Date
		evaluationEntityId?: string
		archived: boolean
		decisionBy?: DecisionByEnum
		stateOfIncorporation?: string
		resubmitted?: boolean
	}
	relationships: ApplicationDocumentRelationship
}

export enum ApplicationDocumentSide {
	Front = "Front",
	Back = "Back",
	Additional = "Additional",
}

export enum ApplicationStatus {
	AwaitingDocuments = "AwaitingDocuments",
	AwaitingInformation = "AwaitingInformation",
	PendingReview = "PendingReview",
	Approved = "Approved",
	Denied = "Denied",
	Pending = "Pending",
	Canceled = "Canceled",
}

export const reevaluableApplicationStatuses: ApplicationStatus[] = [
	ApplicationStatus.PendingReview,
	ApplicationStatus.AwaitingDocuments,
	ApplicationStatus.AwaitingInformation,
]

export enum Assignee {
	Unit = "Unit",
	Org = "Org",
	Bank = "Bank",
}

export enum DecisionMethodType {
	Manually = "Manually",
	Automatically = "Automatically",
	InProgress = "InProgress",
}

export enum ApproveMethodType {
	Manually = "Manually",
	Automatically = "Automatically",
}

export enum DecisionByEnum {
	Unit = "Unit",
	Org = "Org",
	Bank = "Bank",
}

export type BusinessApplicationData = {
	createdAt: Date
	updatedAt?: Date
	status: ApplicationStatus
	name: string
	dba?: string
	address: Permissible<Address>
	phone: Permissible<Phone>
	decisionMethod?: ApproveMethodType
	decisionUserId?: string
	decisionBy?: DecisionByEnum
	decisionReason?: string
	decisionReasonCodes?: EntityDeclineReason[]
	decisionDateTime?: Date
	dateOfIncorporation: Date
	stateOfIncorporation: string
	ein: Permissible<string>
	entityType?: "Corporation" | "LLC" | "PubliclyTradedCorporation"
	contact: BusinessContact
	officer?: Officer
	beneficialOwners?: Array<BeneficialOwner>
	attestedNoBeneficialOwners?: boolean
	purpose: string
	evaluationOutcome: EvaluationOutcome
	evaluationId?: string
	evaluationEntityId?: string
	ip?: string
	website?: string
	hasNoWebsite?: boolean
	tags: {[key: string]: string}
	riskRate?: RiskRate
	evaluationFlags?: string[]
	ipLocationDetails?: IpLocationDetails
	phoneLocationDetails?: PhoneLocationDetails
	archived: boolean
	industry?: IndustryType
	businessVertical?: BusinessVertical
	yearOfIncorporation?: string
	numberOfEmployees?: BusinessNumberOfEmployees
	annualRevenue?: BusinessAnnualRevenue
	countriesOfOperation?: string[]
	stockSymbol?: string
	cashFlow?: CashFlow
	evaluationCodes?: string[]
	publicTradedCompany?: boolean
	assignee: Assignee
	evaluation?: BusinessExternalEvaluation
	externalCip?: boolean
	operatingAddress?: Permissible<Address>
	businessIndustry?: BusinessIndustry
	sourceOfFunds?: BusinessSourceOfFunds
	sourceOfFundsDescription?: string
	accountPurpose?: BusinessAccountPurpose
	accountPurposeDetail?: string
	stockExchangeName?: string
	transactionVolume?: BusinessTransactionVolume
	transactionVolumeDescription?: string
	isRegulated?: boolean
	regulatorName?: string
	usNexus?: string[]
	businessDescription?: string
	customerDueDiligence?: CustomerDueDiligence[]
}

export type ApplicationData = IndividualApplicationData | BusinessApplicationData

export type BusinessApplication = {
	type: "businessApplication"
	id: string
	attributes: BusinessApplicationData
	relationships: {
		documents: {
			data: Array<{type: "document"; id: string}>
		}
		customer?: {
			data: {
				type: "businessCustomer"
				id: string
			}
		}
		org: {
			data: {
				type: "org"
				id: string
			}
		}
		officer?: {
			data: {
				type: "officer"
				id: string
			}
		}
	}
	included: Array<BeneficialOwnerResource>
}

export type IndividualApplication = {
	type: "individualApplication"
	id: string
	attributes: {
		createdAt: Date
		updatedAt?: Date
		status: ApplicationStatus
		fullName: FullName
		ssn: Permissible<string>
		passport: Permissible<string>
		nationality: Permissible<string>
		matriculaConsular: Permissible<string>
		address: Permissible<Address>
		dateOfBirth: Permissible<Date>
		email: Permissible<string>
		phone: Phone
		decisionMethod?: ApproveMethodType
		decisionUserId?: string
		decisionBy?: DecisionByEnum
		decisionReason?: string
		decisionReasonCodes?: EntityDeclineReason[]
		decisionDateTime?: Date
		tin?: string
		evaluationOutcome: EvaluationOutcome
		evaluationId?: string
		evaluationEntityId?: string
		ip?: string
		ein: Permissible<string>
		dba?: string
		soleProprietorship: boolean
		tags: {[key: string]: string}
		riskRate?: RiskRate
		evaluationFlags?: string[]
		evaluationScores?: EvaluationScores
		ipLocationDetails?: IpLocationDetails
		phoneLocationDetails?: PhoneLocationDetails
		maskedSSN?: string
		maskedPassport?: string
		maskedMatriculaConsular?: string
		archived: boolean
		industry?: IndustryType
		idTheftScore?: number
		evaluationCodes?: string[]
		occupation?: Occupation
		sourceOfIncome?: SourceOfIncome
		annualIncome?: AnnualIncome
		numberOfEmployees?: SoleProprietorshipNumberOfEmployees
		annualRevenue?: SoleProprietorshipAnnualRevenue
		businessVertical?: BusinessVertical
		website?: string
		hasNoWebsite?: boolean
		evaluation?: PersonExternalEvaluation
		assignee: Assignee
		businessIndustry?: BusinessIndustry
		sourceOfFunds?: IndividualSourceOfFunds | BusinessSourceOfFunds
		sourceOfFundsDescription?: string
		accountPurpose?: IndividualAccountPurpose | BusinessAccountPurpose
		accountPurposeDetail?: string
		transactionVolume?: IndividualTransactionVolume | SolePropTransactionVolume
		transactionVolumeDescription?: string
		profession?: Profession
		usNexus?: string[]
		isIncorporated?: boolean
		stateOfIncorporation?: string
		yearOfIncorporation?: string
		countriesOfOperation?: string[]
		businessDescription?: string
		customerDueDiligence?: CustomerDueDiligence[]
	}
	relationships: {
		documents: {
			data: Array<{type: "document"; id: string}>
		}
		customer?: {
			data: {
				type: "individualCustomer"
				id: string
			}
		}
		org: {
			data: {
				type: "org"
				id: string
			}
		}
	}
}

export type Application = BusinessApplication | IndividualApplication

export type RequestPassport = {
	fullName: FullName
	dateOfBirth: Date
	passport?: string
	nationality?: string
}

export type RequestSSN = {
	fullName: FullName
	dateOfBirth: Date
	ssn?: string
}

export type RequestMatriculaConsular = {
	fullName: FullName
	dateOfBirth: Date
	matriculaConsular?: string
}
export type RequestAddressVerification = {
	fullName?: FullName
	name?: string
	address: Address
}

export type RequestSelfieVerification = {
	fullName: FullName
}

export type RequestCertificateOfIncorporation = {
	name: string
	stateOfIncorporation: string
}

export type RequestEmployerIdentificationNumberConfirmation = {
	name: string
	ein: string
}

export type EntityDeclineReason = {
	entity: string
	reasons?: string[]
}

export type RequestDocumentRequest =
	| RequestPassport
	| RequestSSN
	| RequestAddressVerification
	| RequestCertificateOfIncorporation
	| RequestEmployerIdentificationNumberConfirmation
	| RequestMatriculaConsular
	| RequestSelfieVerification

type CategoryType = "Risk" | "Informational"

export interface CodeAndDescription {
	code: string
	description: string
	type: {
		module: ReasonCodesKeys
		category: CategoryType
	}
}

type ReasonCodesKeys = "kyc" | "phoneRisk" | "emailRisk" | "addressRisk" | "fraudRisk"

export type ReasonCode = {
	code: string
	description: string
}

export type ReasonCodes = {
	[key in ReasonCodesKeys]?: {
		riskCodes?: ReasonCode[]
		informationalCodes?: ReasonCode[]
	}
}

export enum EvaluationProvidersDataType {
	Individual = "individualApplicationEvaluationProvidersData",
	Business = "businessApplicationEvaluationProvidersData",
}

export type ApplicationEvaluationProvidersData = IndividualEvaluationProvidersData | BusinessEvaluationProvidersData

export type AdverseMediaMatchesType = {
	date?: string
	title: string
	snippet: string
	url: string
	entityName: string
}

export type DeviceFingerprints = {
	iovation: Record<string, any>
}

export type ForName = {
	name: string
}

export type EvaluationForName = {
	forNames?: ForName[]
}

export type AdverseMediaMatches = EvaluationForName & {
	score: number
	matchItems: AdverseMediaMatchesType[]
	attributes: {[key: string]: string[]}
}

export type Sanctions = EvaluationForName & {
	listName: string
	score?: number
	sourceUrls: string[]
	attributes: {[key: string]: string[]}
}

export type Pep = EvaluationForName & {
	score?: number
	sourceUrls: string[]
	attributes: {[key: string]: string[]}
}

export enum WatchlistMatchesTypes {
	Sanctions = "Sanctions",
	AdverseMediaMatches = "Adverse Media",
	Pep = "PEP",
}

type SanctionsData = {
	type: WatchlistMatchesTypes.Sanctions
	data?: Sanctions[]
}

type AdverseMediaMatchesData = {
	type: WatchlistMatchesTypes.AdverseMediaMatches
	data?: AdverseMediaMatches[]
}
type PepsData = {
	type: WatchlistMatchesTypes.Pep
	data?: Pep[]
}

export type WatchlistMatchesData = SanctionsData | AdverseMediaMatchesData | PepsData

export type PersonExternalEvaluation = {
	reasonCodes?: CodeAndDescription[]
	adverseMedia?: AdverseMediaMatches[]
	sanctions?: Sanctions[]
	pep?: Pep[]
	deviceFingerprints?: DeviceFingerprints
}

export type BusinessExternalEvaluation = {
	sanctions?: Sanctions[]
}

export type IndividualEvaluationProvidersData = {
	type: EvaluationProvidersDataType.Individual
	attributes: {
		evaluation: {
			reasonCodes?: ReasonCodes
			adverseMediaMatches?: AdverseMediaMatches[]
			sanctions?: Sanctions[]
			pep?: Pep[]
		}
	}
	relationships: {
		application: {
			data: {
				type: "application"
				id: string
			}
		}
	}
}

export type BusinessEvaluationProvidersData = {
	type: EvaluationProvidersDataType.Business
	attributes: {
		officerEvaluation: {
			reasonCodes?: ReasonCodes
		}
	}
	relationships: {
		application: {
			data: {
				type: "application"
				id: string
			}
		}
	}
}

export function convertReasonsToReasonCodes(reasons?: CodeAndDescription[]): ReasonCodes | undefined {
	if (!reasons) return

	const reasonCodes: ReasonCodes = {}

	reasons.forEach(({code, description, type}) => {
		const {module, category} = type

		if (!reasonCodes[module]) {
			reasonCodes[module] = {}
		}

		const moduleEntry = reasonCodes[module]

		if (moduleEntry) {
			if (category === "Risk") {
				if (!moduleEntry.riskCodes) {
					moduleEntry.riskCodes = []
				}
				moduleEntry.riskCodes.push({code, description})
			} else if (category === "Informational") {
				if (!moduleEntry.informationalCodes) {
					moduleEntry.informationalCodes = []
				}
				moduleEntry.informationalCodes.push({code, description})
			}
		}
	})

	return reasonCodes
}

export function isApplicationDocument(resource: Resource): resource is ApplicationDocument {
	return resource.type === "document"
}

export function evaluateApplicationLocation(
	address: Address,
	locationDetails: PhoneLocationDetails | IpLocationDetails,
	locationType: "Phone" | "IP"
) {
	const stateValues = [address.state, locationDetails.stateCode]
	const countryValues = [address.country, locationDetails.countryCode]

	const stateMatch = new Set(stateValues).size === 1
	const countryMatch = new Set(countryValues).size === 1

	if (stateMatch && countryMatch) {
		return `${locationType} Location Match`
	}
	if (stateMatch && !countryMatch) {
		return `${locationType} Location Country Mismatch`
	}
	if (!stateMatch && countryMatch) {
		return `${locationType} Location State Mismatch`
	}

	return `${locationType} Location Mismatch`
}

export async function findApplication(
	accessToken: string,
	offset: number,
	limit: number,
	status: ApplicationStatus[],
	sort: string,
	searchQuery: string,
	orgs?: string[],
	decisionMethod?: DecisionMethodType[],
	assignees?: Assignee[]
): Promise<Result<OkDocument<Array<Application>>, ErrorDocument>> {
	if (status.length === 0) return ok({data: []})
	if (decisionMethod?.length === 0) return ok({data: []})

	const searchQueryValue = searchQuery != "" ? searchQuery : null
	const orgFilter = orgs && orgs.length > 0 ? orgs : null
	const assigneeFilter =
		assignees && assignees.length > 0 && !Object.values(Assignee).every((assignee) => assignees?.includes(assignee))
			? assignees
			: null

	const query = {
		page: {
			limit,
			offset,
		},
		filter: {
			status: status,
			query: searchQueryValue,
			orgs: orgFilter,
			decisionMethod: decisionMethod,
			assignee: assigneeFilter,
		},
		extraFields: {
			application: "evaluationOutcome",
		},
		include: "org",
		sort,
	}
	return await getResource<Array<Application>>("applications", accessToken, query)
}

export async function exportApplications(
	accessToken: string,
	status: ApplicationStatus[],
	sort: string,
	searchQuery: string,
	orgs?: string[]
): Promise<Result<OkDocument<Array<Application>>, ErrorDocument>> {
	if (status.length === 0) return ok({data: []})

	const searchQueryValue = searchQuery != "" ? searchQuery : null

	const orgFilter = orgs && orgs.length > 0 ? orgs : null

	const query = {
		page: {
			limit: 10000,
			offset: 0,
		},
		filter: {
			status: status,
			query: searchQueryValue,
			orgs: orgFilter,
		},
		include: "org",
		sort,
	}

	return await getFile("applications", accessToken, query)
}

export async function approveApplication(
	accessToken: string,
	application: Application,
	reason: string,
	riskRate: RiskRate,
	evaluatedAt?: Date
) {
	const data = {
		type: "applicationApprove",
		attributes: {
			reason,
			riskRate,
			evaluatedAt,
		},
	}

	return await createResource<Application>(`applications/${application.id}/approve`, accessToken, data)
}

export async function denyApplication(
	accessToken: string,
	application: Application,
	reason: string,
	reasons: EntityDeclineReason[],
	evaluatedAt?: Date
) {
	const data = {
		type: "applicationDeny",
		attributes: {
			reason,
			reasons,
			evaluatedAt,
		},
	}

	return await createResource<Application>(`applications/${application.id}/deny`, accessToken, data)
}

export async function cancelApplication(accessToken: string, application: Application, reason: string) {
	const data = {
		type: "applicationCancel",
		attributes: {
			reason,
		},
	}

	return await createResource<Application>(`applications/${application.id}/cancel`, accessToken, data)
}

export async function getIndividualApplication(accessToken: string, id: string) {
	return await getResource<IndividualApplication>(`applications/${id}`, accessToken, {
		extraFields: {
			application:
				"evaluationFlags,evaluationOutcome,maskedSSN,maskedPassport,maskedMatriculaConsular,decisionReasonCodes,decisionDateTime,customerDueDiligence",
		},
		include: "org",
	})
}

export async function downloadDocument(
	applicationId: string,
	documentId: string,
	accessToken: string,
	side: ApplicationDocumentSide
) {
	return await getFile(
		`applications/${applicationId}/documents/${documentId}/download/${side.toLocaleLowerCase()}`,
		accessToken,
		undefined,
		undefined,
		"arraybuffer",
		true
	)
}

export async function getApplication(accessToken: string, id: string) {
	return await getResource<Application>(`applications/${id}`, accessToken, {
		extraFields: {
			application:
				"evaluationFlags,evaluationOutcome,maskedSSN,maskedPassport,maskedMatriculaConsular,decisionReasonCodes,decisionDateTime,customerDueDiligence",
			officer: "evaluationFlags,maskedSSN,maskedPassport,maskedMatriculaConsular",
			beneficialOwner: "evaluationFlags,maskedSSN,maskedPassport,maskedMatriculaConsular",
			document: "businessName,fullName",
		},
		include: "org",
		includeEvaluation: "true",
	})
}

export async function approveDocument(accessToken: string, applicationId: string, documentId: string) {
	return await createResource<Application>(
		`applications/${applicationId}/documents/${documentId}/approve`,
		accessToken,
		null
	)
}

export async function rejectDocument(
	accessToken: string,
	applicationId: string,
	documentId: string,
	reasonCode: string,
	reason: string
) {
	const data = {
		type: "documentReject",
		attributes: {
			reasonCode,
			reason,
		},
	}

	return await createResource<Application>(
		`applications/${applicationId}/documents/${documentId}/reject`,
		accessToken,
		data
	)
}

export async function uploadDocument(
	accessToken: string,
	applicationId: string,
	documentId: string,
	documentFile: any,
	documentType: string | undefined,
	documentSide: ApplicationDocumentSide
) {
	return await uploadResource<Application>({
		path: `applications/${applicationId}/documents/${documentId}${
			documentSide == ApplicationDocumentSide.Back ? "/back" : ""
		}`,
		accessToken,
		data: documentFile,
		type: documentType,
	})
}

export type EvaluateionParams = {
	useSelfieVerification?: "Never" | "ReplaceIdentification" | "Always"
	requireIdVerification?: boolean
}

export type IndividualApplicationData = {
	ssn?: string
	passport?: string
	nationality?: string
	matriculaConsular?: string
	dob?: Date
	address?: Address
	phone?: Phone
	email?: string
	ein?: string
	dba?: string
	fullName?: FullName
	industry?: IndustryType
	occupation?: Occupation
	sourceOfIncome?: SourceOfIncome
	annualIncome?: AnnualIncome
	businessVertical?: BusinessVertical
	annualRevenue?: SoleProprietorshipAnnualRevenue
	numberOfEmployees?: SoleProprietorshipNumberOfEmployees
	website?: string
	businessIndustry?: BusinessIndustry
	sourceOfFunds?: IndividualSourceOfFunds | BusinessSourceOfFunds
	sourceOfFundsDescription?: string
	accountPurpose?: IndividualAccountPurpose | BusinessAccountPurpose
	accountPurposeDetail?: string
	transactionVolume?: IndividualTransactionVolume | SolePropTransactionVolume
	transactionVolumeDescription?: string
	profession?: Profession
	usNexus?: string[]
	isIncorporated?: boolean
	stateOfIncorporation?: string
	yearOfIncorporation?: string
	countriesOfOperation?: string[]
	businessDescription?: string
}
type ResubmitIndividualApplicationPickedData =
	| "email"
	| "ssn"
	| "passport"
	| "matriculaConsular"
	| "nationality"
	| "fullName"
	| "dob"
	| "address"
	| "phone"
	| "ein"
	| "website"
	| "businessIndustry"
	| "sourceOfFunds"
	| "sourceOfFundsDescription"
	| "accountPurpose"
	| "accountPurposeDetail"
	| "transactionVolume"
	| "transactionVolumeDescription"
	| "profession"
	| "usNexus"
	| "isIncorporated"
	| "stateOfIncorporation"
	| "yearOfIncorporation"
	| "countriesOfOperation"
	| "businessDescription"

export type ResubmitIndividualApplicationData = Pick<
	IndividualApplicationData,
	ResubmitIndividualApplicationPickedData
> & {evaluationParams?: EvaluateionParams} & {reasonText: string}

export async function resubmitOfficersBusinessApplication(
	accessToken: string,
	application: Application,
	officerId: string,
	data: ReevaluatedOfficerApplicationData,
	reasonText: string
) {
	const url = `officers/${officerId}/resubmit`
	const idempotencyKey = `dashboard-officer-resubmit-${uuidv4()}`
	const body = {
		type: "officerResubmit",
		attributes: {...data, idempotencyKey: idempotencyKey, reasonText: reasonText},
		relationships: {
			application: {
				data: {
					type: "businessApplication",
					id: application.id,
				},
			},
		},
	}

	return await updateResource<Officer>(url, accessToken, body)
}

export async function resubmitBeneficialOwnerBusinessApplication(
	accessToken: string,
	application: Application,
	beneficialOwner: BeneficialOwnerResource,
	data: ReevaluatedBeneficialOwnerApplicationData,
	reasonText: string
) {
	const url = `beneficial-owner/${beneficialOwner.id}/resubmit`
	const idempotencyKey = `dashboard-beneficialOwner-resubmit-${uuidv4()}`
	const body = {
		type: "beneficialOwnerResubmit",
		attributes: {...data, idempotencyKey: idempotencyKey, reasonText: reasonText},
		relationships: {
			application: {
				data: {
					type: "businessApplication",
					id: application.id,
				},
			},
		},
	}

	return await updateResource<BeneficialOwnerResource>(url, accessToken, body)
}

export async function resubmitBusinessApplication(
	accessToken: string,
	application: Application,
	data: ReevaluatedBusinessApplicationDataRequest,
	reasonText: string
) {
	const url = `applications/${application.id}/resubmit`
	const idempotencyKey = `dashboard-business-application-resubmit-${uuidv4()}`
	const body = {
		type: "businessApplicationResubmit",
		attributes: {...data, idempotencyKey: idempotencyKey, reasonText: reasonText},
	}

	return await updateResource<Application>(url, accessToken, body)
}

export async function resubmitIndividualApplication(
	accessToken: string,
	application: Application,
	data: ResubmitIndividualApplicationData
) {
	const {
		email,
		ssn,
		passport,
		matriculaConsular,
		nationality,
		fullName,
		dob,
		phone,
		evaluationParams,
		address,
		reasonText,
		ein,
		website,
		businessIndustry,
		sourceOfFunds,
		sourceOfFundsDescription,
		accountPurpose,
		accountPurposeDetail,
		transactionVolume,
		transactionVolumeDescription,
		profession,
		usNexus,
		isIncorporated,
		stateOfIncorporation,
		yearOfIncorporation,
		countriesOfOperation,
		businessDescription,
	} = data
	const url = `applications/${application.id}/resubmit`

	const body = {
		type: "individualApplicationResubmit",
		attributes: {
			ssn,
			email,
			phone,
			address,
			fullName,
			passport,
			nationality,
			evaluationParams,
			matriculaConsular,
			dateOfBirth: dob ? moment(dob).format("YYYY-MM-DD") : undefined,
			ein,
			website,
			idempotencyKey: `dashboard-application-resubmit-${uuidv4()}`,
			reasonText,
			businessIndustry,
			sourceOfFunds,
			sourceOfFundsDescription,
			accountPurpose,
			accountPurposeDetail,
			transactionVolume,
			transactionVolumeDescription,
			profession,
			usNexus,
			isIncorporated,
			stateOfIncorporation,
			yearOfIncorporation,
			countriesOfOperation,
			businessDescription,
		},
	}

	return updateResource<Application>(url, accessToken, body)
}

export async function manualCompletePending(
	accessToken: string,
	application: {attributes: {evaluationEntityId?: string; evaluationId?: string}}
) {
	const url = `${apiUrl}/applications/complete-pending`
	const headers = {
		"Content-Type": "application/json",
		Authorization: `Bearer ${accessToken}`,
	}
	const body = {
		data: {
			type: "application",
			attributes: {
				entityId: application.attributes.evaluationEntityId,
				evaluationId: application.attributes.evaluationId,
			},
		},
	}
	return await post<unknown, ErrorDocument>(url, body, {headers})
}

export async function updateIndividualApplication(
	accessToken: string,
	application: Application,
	{
		ssn,
		passport,
		matriculaConsular,
		dob,
		address,
		phone,
		nationality,
		email,
		ein,
		dba,
		fullName,
		industry,
		occupation,
		sourceOfIncome,
		annualIncome,
		annualRevenue,
		businessVertical,
		numberOfEmployees,
		website,
		businessIndustry,
		sourceOfFunds,
		sourceOfFundsDescription,
		accountPurpose,
		accountPurposeDetail,
		transactionVolume,
		transactionVolumeDescription,
		profession,
		usNexus,
		isIncorporated,
		stateOfIncorporation,
		yearOfIncorporation,
		businessDescription,
	}: IndividualApplicationData
) {
	return await updateResource<Application>(`applications/${application.id}`, accessToken, {
		type: application.type,
		attributes: Object.assign(
			{},
			fullName ? {fullName: fullName} : undefined,
			ssn ? {ssn: ssn} : undefined,
			passport ? {passport: passport} : undefined,
			nationality ? {nationality: nationality} : undefined,
			matriculaConsular ? {matriculaConsular: matriculaConsular} : undefined,
			dob ? {dateOfBirth: moment(dob).format("YYYY-MM-DD")} : undefined,
			address ? {address: address} : undefined,
			phone ? {phone: phone} : undefined,
			email ? {email: email} : undefined,
			ein ? {ein: ein} : undefined,
			dba ? {dba: dba} : undefined,
			industry ? {industry: industry} : undefined,
			occupation ? {occupation: occupation} : undefined,
			sourceOfIncome ? {sourceOfIncome: sourceOfIncome} : undefined,
			annualIncome ? {annualIncome: annualIncome} : undefined,
			businessVertical ? {businessVertical: businessVertical} : undefined,
			annualRevenue ? {annualRevenue: annualRevenue} : undefined,
			numberOfEmployees ? {numberOfEmployees: numberOfEmployees} : undefined,
			website ? {website: website} : undefined,
			businessIndustry ? {businessIndustry: businessIndustry} : undefined,
			sourceOfFunds ? {sourceOfFunds: sourceOfFunds} : undefined,
			sourceOfFundsDescription ? {sourceOfFundsDescription: sourceOfFundsDescription} : undefined,
			accountPurpose ? {accountPurpose: accountPurpose} : undefined,
			accountPurposeDetail ? {accountPurposeDetail: accountPurposeDetail} : undefined,
			transactionVolume ? {transactionVolume: transactionVolume} : undefined,
			transactionVolumeDescription ? {transactionVolumeDescription: transactionVolumeDescription} : undefined,
			profession ? {profession: profession} : undefined,
			usNexus ? {usNexus: usNexus} : undefined,
			isIncorporated !== undefined ? {isIncorporated: isIncorporated} : undefined,
			stateOfIncorporation ? {stateOfIncorporation: stateOfIncorporation} : undefined,
			yearOfIncorporation ? {yearOfIncorporation: yearOfIncorporation} : undefined,
			businessDescription ? {businessDescription: businessDescription} : undefined
		),
	})
}

export async function updateBusinessApplication(
	accessToken: string,
	application: Application,
	{
		officerName,
		officerTitle,
		officerSSN,
		officerPassport,
		officerMatriculaConsular,
		officerDob,
		officerAddress,
		officerPhone,
		officerNationality,
		officerEmail,
		officerOccupation,
		officerSourceOfIncome,
		officerAnnualIncome,
		contactPhone,
		contactName,
		contactEmail,
		address,
		phone,
		ein,
		stateOfIncorporation,
		dba,
		name,
		industry,
		businessVertical,
		yearOfIncorporation,
		numberOfEmployees,
		annualRevenue,
		countriesOfOperation,
		cashFlow,
		website,
		stockSymbol,
		operatingAddress,
		businessIndustry,
		sourceOfFunds,
		sourceOfFundsDescription,
		accountPurpose,
		accountPurposeDetail,
		stockExchangeName,
		transactionVolume,
		transactionVolumeDescription,
		isRegulated,
		regulatorName,
		usNexus,
		businessDescription,
	}: {
		officerName?: FullName
		officerTitle?: OfficerTitle
		officerSSN?: string
		officerPassport?: string
		officerNationality?: string
		officerMatriculaConsular?: string
		officerDob?: Date
		officerAddress?: Address
		officerPhone?: Phone
		officerEmail?: string
		officerOccupation?: Occupation
		officerSourceOfIncome?: SourceOfIncome
		officerAnnualIncome?: AnnualIncome
		contactName?: FullName
		contactPhone?: Phone
		contactEmail?: string
		address?: Address
		phone?: Phone
		ein?: string
		stateOfIncorporation?: string
		dba?: string
		name?: string
		industry?: IndustryType
		businessVertical?: BusinessVertical
		yearOfIncorporation?: string
		numberOfEmployees?: BusinessNumberOfEmployees
		annualRevenue?: BusinessAnnualRevenue
		countriesOfOperation?: string[]
		cashFlow?: CashFlow
		website?: string
		stockSymbol?: string
		operatingAddress?: Address
		businessIndustry?: BusinessIndustry
		sourceOfFunds?: BusinessSourceOfFunds
		sourceOfFundsDescription?: string
		accountPurpose?: BusinessAccountPurpose
		accountPurposeDetail?: string
		stockExchangeName?: string
		transactionVolume?: BusinessTransactionVolume
		transactionVolumeDescription?: string
		isRegulated?: boolean
		regulatorName?: string
		usNexus?: string[]
		businessDescription?: string
	}
) {
	const officer =
		officerName ||
		officerTitle ||
		officerSSN ||
		officerPassport ||
		officerNationality ||
		officerMatriculaConsular ||
		officerDob ||
		officerAddress ||
		officerPhone ||
		officerEmail ||
		officerOccupation ||
		officerSourceOfIncome ||
		officerAnnualIncome
			? {
					fullName: officerName,
					title: officerTitle,
					ssn: officerSSN,
					passport: officerPassport,
					nationality: officerNationality,
					matriculaConsular: officerMatriculaConsular,
					dateOfBirth: officerDob ? moment(officerDob).format("YYYY-MM-DD") : undefined,
					address: officerAddress,
					phone: officerPhone,
					email: officerEmail,
					occupation: officerOccupation,
					sourceOfIncome: officerSourceOfIncome,
					annualIncome: officerAnnualIncome,
			  }
			: undefined

	// Create the contact object conditionally
	const contact =
		contactName || contactPhone || contactEmail
			? {
					fullName: contactName,
					phone: contactPhone,
					email: contactEmail,
			  }
			: undefined

	return await updateResource<Application>(`applications/${application.id}`, accessToken, {
		type: application.type,
		attributes: Object.assign(
			{},
			address ? {address: address} : undefined,
			phone ? {phone: phone} : undefined,
			ein ? {ein: ein} : undefined,
			stateOfIncorporation ? {stateOfIncorporation: stateOfIncorporation} : undefined,
			dba ? {dba: dba} : undefined,
			name ? {name: name} : undefined,
			industry ? {industry: industry} : undefined,
			businessVertical ? {businessVertical: businessVertical} : undefined,
			yearOfIncorporation ? {yearOfIncorporation: yearOfIncorporation} : undefined,
			numberOfEmployees ? {numberOfEmployees: numberOfEmployees} : undefined,
			annualRevenue ? {annualRevenue: annualRevenue} : undefined,
			countriesOfOperation ? {countriesOfOperation: countriesOfOperation} : undefined,
			cashFlow ? {cashFlow: cashFlow} : undefined,
			website ? {website: website} : undefined,
			stockSymbol ? {stockSymbol: stockSymbol} : undefined,
			officer ? {officer: officer} : undefined,
			contact ? {contact: contact} : undefined,
			operatingAddress ? {operatingAddress: operatingAddress} : undefined,
			businessIndustry ? {businessIndustry: businessIndustry} : undefined,
			sourceOfFunds ? {sourceOfFunds: sourceOfFunds} : undefined,
			sourceOfFundsDescription ? {sourceOfFundsDescription: sourceOfFundsDescription} : undefined,
			accountPurpose ? {accountPurpose: accountPurpose} : undefined,
			accountPurposeDetail ? {accountPurposeDetail: accountPurposeDetail} : undefined,
			stockExchangeName ? {stockExchangeName: stockExchangeName} : undefined,
			transactionVolume ? {transactionVolume: transactionVolume} : undefined,
			transactionVolumeDescription ? {transactionVolumeDescription: transactionVolumeDescription} : undefined,
			isRegulated !== undefined ? {isRegulated: isRegulated} : undefined,
			regulatorName ? {regulatorName: regulatorName} : undefined,
			usNexus ? {usNexus: usNexus} : undefined,
			businessDescription ? {businessDescription: businessDescription} : undefined
		),
	})
}

export type ApplicationRelationship = {application?: {data: {type: "application"; id: string}}}
export type ProductApplicationRelationship = {productApplication?: {data: {type: "productApplication"; id: string}}}
export type OfficerRelationship = {
	officer?: {data: {type: "officer"; id: string}}
}
export type BeneficialOwnerRelationship = {beneficialOwner?: {data: {type: "beneficialOwner"; id: string}}}

export type DocumentTarget = {officerId: string} | {beneficialOwnerId: string} | {applicationId: string}

export async function updateDocument(
	accessToken: string,
	applicationId: string,
	documentId: string,
	document: PatchApplicationDocument
) {
	return await updateResource<ApplicationDocument>(
		`applications/${applicationId}/documents/${documentId}`,
		accessToken,
		document
	)
}

export async function updateApplicationTags(
	accessToken: string,
	applicationId: string,
	applicationType: Application["type"],
	tags: {[key: string]: string | null}
) {
	const result = await updateResource<Application>(`applications/${applicationId}`, accessToken, {
		type: applicationType,
		attributes: {
			tags,
		},
	})
	return result.map((v) => v.data)
}

export async function requestDocument(
	accessToken: string,
	applicationId: string,
	documentType: string,
	target?: DocumentTarget
) {
	if (!target) {
		return err({errors: [{title: "An unexpected error has occurred", status: "400"}]})
	}

	const data = {
		type: documentType,
		relationships: buildApplicationDocumentRelationships(target),
	}

	return await createResource<ApplicationDocument>(`applications/${applicationId}/documents/request`, accessToken, data)
}

function buildApplicationDocumentRelationships(target: DocumentTarget) {
	if ("officerId" in target) {
		return {officer: {data: {type: "officer", id: target.officerId}}}
	}
	if ("beneficialOwnerId" in target) {
		return {beneficialOwner: {data: {type: "beneficialOwner", id: target.beneficialOwnerId}}}
	}
	return {application: {data: {type: "application", id: target.applicationId}}}
}

export enum ApplicationType {
	individual = "Individual",
	business = "Business",
}

export const ApplicationTypeIcons: Record<ApplicationType, IcomoonIconName> = {
	[ApplicationType.business]: "toolbox",
	[ApplicationType.individual]: "user-geometric-action---users",
}

export function getApplicationName(application: Application) {
	switch (application.type) {
		case "businessApplication":
			return application.attributes.name
		case "individualApplication":
			return `${application.attributes.fullName.first} ${application.attributes.fullName.last}`
	}
}

export function isBusinessApplication(application: Application): application is BusinessApplication {
	return application.type == "businessApplication"
}

export function isBusinessApplicationDocument(
	application: OkDocument<Application>
): application is OkDocument<BusinessApplication> {
	return application.data.type === "businessApplication"
}

export function isIndividualApplicationDocument(
	application: OkDocument<Application>
): application is OkDocument<IndividualApplication> {
	return application.data.type === "individualApplication"
}

export function isBeneficialOwnerResource(resource: Resource): resource is BeneficialOwnerResource {
	return resource.type === "beneficialOwner"
}

export async function getDocumentLink(
	applicationId: string,
	documentId: string,
	accessToken: string,
	side: ApplicationDocumentSide
) {
	return await getResource<DocumentLink>(
		`applications/${applicationId}/documents/${documentId}/link/${side.toLocaleLowerCase()}`,
		accessToken
	)
}

export function hasAdditionalInformation({
	occupation,
	annualIncome,
	sourceOfIncome,
}: {
	occupation?: Occupation
	annualIncome?: AnnualIncome
	sourceOfIncome?: SourceOfIncome
}) {
	return occupation || annualIncome || sourceOfIncome
}

export const DOCUMENT_REASONS = [
	"Altered/Fictitious Documents", //not exists
	"Multiple Failed Requests for Documents", //not exists
]

export const IDENTITY_REASONS = [
	"Identity - failed to verify / high risk",
	"SSN - failed to verify / high risk", //not exists
	"DOB - failed to verify / high risk", //not exists
	"Address - failed to verify / high risk",
	"Name - failed to verify / high risk", //not exists
	"Phone - failed to verify / high risk",
	"Email - high risk",
	"Device/IP - high risk",
]

export const ACTIVITY_REASONS = [
	"Applicant on Unit's internal Denylist", //not exists
	"Fraud Warning", //not exists
	"Fraud Risk", //not exists
	"Suspicious connection to other applications", //not exists
	"Adverse media match",
	"OFAC or other watchlist",
]

export const REASON_CODES_TO_MESSAGE = new Map([
	["R561", "Email - high risk"],
	["R208", "Identity - failed to verify / high risk"],
	["R610", "Address - failed to verify / high risk"],
	["R705", "Address - failed to verify / high risk"],
	["R608", "Phone - failed to verify / high risk"],
	["594", "Identity - failed to verify / high risk"],
	["R566", "Email - high risk"],
	["R601", "Phone - failed to verify / high risk"],
	["641", "Email - high risk"],
	["R606", "Phone - failed to verify / high risk"],
	["230", "Identity - failed to verify / high risk"],
	["R568", "Email - high risk"],
	["R560", "Other"],
	["R617", "Phone - failed to verify / high risk"],
	["I564", "Email - high risk"],
	["R919", "Address - failed to verify / high risk"],
	["R616", "Phone - failed to verify / high risk"],
	["R604", "Phone - failed to verify / high risk"],
	["627", "Device/IP - high risk"],
	["628", "Device/IP - high risk"],
	["R615", "Phone - failed to verify / high risk"],
	["675", "Email - high risk"],
	["593", "Identity - failed to verify / high risk"],
	["R207", "Identity - failed to verify / high risk"],
	["R551", "Email - high risk"],
	["I713", "Address - failed to verify / high risk"],
	["R637", "Phone - failed to verify / high risk"],
	["R636", "Phone - failed to verify / high risk"],
	["R928", "Identity - failed to verify / high risk"],
	["R563", "Email - high risk"],
	["R605", "Phone - failed to verify / high risk"],
	["R620", "Phone - failed to verify / high risk"],
	["R622", "Phone - failed to verify / high risk"],
	["R922", "Identity - failed to verify / high risk"],
	["R619", "Device/IP - high risk"],
	["R642", "Device/IP - high risk"],
	["R720", "Address - failed to verify / high risk"],
	["574", "Phone - failed to verify / high risk"],
	["R902", "Identity - failed to verify / high risk"],
	["R709", "Address - failed to verify / high risk"],
	["R903", "Identity - failed to verify / high risk"],
	["592", "Identity - failed to verify / high risk"],
	["R940", "Identity - failed to verify / high risk"],
	["R934", "Identity - failed to verify / high risk"],
	["R933", "Identity - failed to verify / high risk"],
	["483", "Phone - failed to verify / high risk"],
	["R941", "Phone - failed to verify / high risk"],
	["I917", "Identity - failed to verify / high risk"],
	["R901", "Identity - failed to verify / high risk"],
	["R628", "Phone - failed to verify / high risk"],
	["R569", "Email - high risk"],
	["R713", "Address - failed to verify / high risk"],
	["R948", "Address - failed to verify / high risk"],
	["564", "Phone - failed to verify / high risk"],
	["R701", "Address - failed to verify / high risk"],
	["R939", "Identity - failed to verify / high risk"],
	["R627", "Phone - failed to verify / high risk"],
	["R703", "Address - failed to verify / high risk"],
	["R916", "Address - failed to verify / high risk"],
	["R930", "Identity - failed to verify / high risk"],
	["596", "Identity - failed to verify / high risk"],
	["R947", "Phone - failed to verify / high risk"],
	["R920", "Identity - failed to verify / high risk"],
	["R978", "Identity - failed to verify / high risk"],
	["R624", "Phone - failed to verify / high risk"],
	["233", "Identity - failed to verify / high risk"],
	["R980", "Identity - failed to verify / high risk"],
	["R955", "Identity - failed to verify / high risk"],
	["613", "Identity - failed to verify / high risk"],
	["614", "Identity - failed to verify / high risk"],
	["R204", "Identity - failed to verify / high risk"],
	["R702", "Address - failed to verify / high risk"],
	["R954", "Document verification failed (Technical)"],
	["R927", "Identity - failed to verify / high risk"],
	["R911", "Identity - failed to verify / high risk"],
	["I202", "Document verification failed (Technical)"],
	["R631", "Phone - failed to verify / high risk"],
	["238", "Identity - failed to verify / high risk"],
	["R957", "Identity - failed to verify / high risk"],
	["591", "Identity - failed to verify / high risk"],
	["R613", "Phone - failed to verify / high risk"],
	["R603", "Phone - failed to verify / high risk"],
	["R956", "Identity - failed to verify / high risk"],
	["R712", "Address - failed to verify / high risk"],
	["R961", "Address - failed to verify / high risk"],
	["R626", "Phone - failed to verify / high risk"],
	["595", "Identity - failed to verify / high risk"],
	["R565", "Email - high risk"],
	["597", "Identity - failed to verify / high risk"],
	["232", "Identity - failed to verify / high risk"],
	["R907", "Identity - failed to verify / high risk"],
	["R557", "Email - high risk"],
	["R206", "Identity - failed to verify / high risk"],
	["R621", "Phone - failed to verify / high risk"],
	["R205", "Identity - failed to verify / high risk"],
	["867", "Address - failed to verify / high risk"],
	["658", "Identity - failed to verify / high risk"],
	["R963", "Address - failed to verify / high risk"],
	["180", "Device/IP - high risk"],
	["567", "Phone - failed to verify / high risk"],
	["580", "Email - high risk"],
	["R909", "Identity - failed to verify / high risk"],
	["R567", "Email - high risk"],
	["R629", "Phone - failed to verify / high risk"],
	["R558", "Email - high risk"],
	["R602", "Phone - failed to verify / high risk"],
	["R611", "Phone - failed to verify / high risk"],
	["R707", "Address - failed to verify / high risk"],
	["I714", "Address - failed to verify / high risk"],
	["I911", "Address - failed to verify / high risk"],
	["R630", "Phone - failed to verify / high risk"],
	["520", "Address - failed to verify / high risk"],
	["R625", "Phone - failed to verify / high risk"],
	["524", "Address - failed to verify / high risk"],
	["R202", "Identity - failed to verify / high risk"],
	["600", "Phone - failed to verify / high risk"],
	["646", "Phone - failed to verify / high risk"],
	["R203", "Identity - failed to verify / high risk"],
	["163", "Address - failed to verify / high risk"],
	["657", "Address - failed to verify / high risk"],
	["R562", "Email - high risk"],
	["R187", "Address - failed to verify / high risk"],
	["R708", "Address - failed to verify / high risk"],
	["R350", "Identity - failed to verify / high risk"],
	["R635", "Phone - failed to verify / high risk"],
	["R913", "Identity - failed to verify / high risk"],
	["248", "Identity - failed to verify / high risk"],
	["589", "Address - failed to verify / high risk"],
	["500", "Identity - failed to verify / high risk"],
	["569", "Phone - failed to verify / high risk"],
	["R977", "Identity - failed to verify / high risk"],
	["507", "Identity - failed to verify / high risk"],
	["498", "Address - failed to verify / high risk"],
	["R188", "Address - failed to verify / high risk"],
	["R201", "Identity - failed to verify / high risk"],
	["499", "Identity - failed to verify / high risk"],
	["R564", "Email - high risk"],
	["R351", "Identity - failed to verify / high risk"],
	["I904", "Document verification failed (Technical)"],
	["616", "Phone - failed to verify / high risk"],
	["R559", "Email - high risk"],
	["R520", "Email - high risk"],
	["R641", "Device/IP - high risk"],
	["R704", "Address - failed to verify / high risk"],
	["R932", "Address - failed to verify / high risk"],
	["R979", "Identity - failed to verify / high risk"],
	["I931", "Identity - failed to verify / high risk"],
	["157", "Address - failed to verify / high risk"],
	["506", "Identity - failed to verify / high risk"],
	["626", "Device/IP - high risk"],
	["639", "Address - failed to verify / high risk"],
	["R352", "Identity - failed to verify / high risk"],
	["733", "Address - failed to verify / high risk"],
	["10", "Identity - failed to verify / high risk"],
	["576", "Phone - failed to verify / high risk"],
	["88", "Identity - failed to verify / high risk"],
	["573", "Phone - failed to verify / high risk"],
	["612", "Identity - failed to verify / high risk"],
	["554", "Identity - failed to verify / high risk"],
	["504", "Identity - failed to verify / high risk"],
	["R403", "Device/IP - high risk"],
	["R406", "Device/IP - high risk"],
	["I401", "Device/IP - high risk"],
	["I402", "Device/IP - high risk"],
	["I403", "Device/IP - high risk"],
	["I410", "Device/IP - high risk"],
	["I411", "Device/IP - high risk"],
	["I412", "Device/IP - high risk"],
	["I413", "Device/IP - high risk"],
	["I414", "Device/IP - high risk"],
	["I415", "Device/IP - high risk"],
	["R845", "Identity - failed to verify / high risk"],
	["I856", "Identity - failed to verify / high risk"],
	["R904", "Address - failed to verify / high risk"],
	["R905", "Phone - failed to verify / high risk"],
	["R906", "Identity - failed to verify / high risk"],
	["R908", "Identity - failed to verify / high risk"],
	["R912", "Identity - failed to verify / high risk"],
	["R914", "Phone - failed to verify / high risk"],
	["R915", "Phone - failed to verify / high risk"],
	["R917", "Address - failed to verify / high risk"],
	["R918", "Identity - failed to verify / high risk"],
	["R921", "Phone - failed to verify / high risk"],
	["R929", "Identity - failed to verify / high risk"],
	["R931", "Address - failed to verify / high risk"],
	["I999", "Identity - failed to verify / high risk"],
	["R936", "Phone - failed to verify / high risk"],
	["R937", "Phone - failed to verify / high risk"],
	["R938", "Address - failed to verify / high risk"],
	["R942", "Phone - failed to verify / high risk"],
	["R943", "Phone - failed to verify / high risk"],
	["R945", "Phone - failed to verify / high risk"],
	["R953", "Identity - failed to verify / high risk"],
	["R958", "Address - failed to verify / high risk"],
	["R962", "Phone - failed to verify / high risk"],
	["R966", "Identity - failed to verify / high risk"],
	["R106", "Identity - failed to verify / high risk"],
	["R110", "Email - high risk"],
	["R111", "Identity - failed to verify / high risk"],
	["R112", "Identity - failed to verify / high risk"],
	["R113", "Phone - failed to verify / high risk"],
	["R129", "Adverse media match"],
	["R130", "Adverse media match"],
	["R131", "Adverse media match"],
	["R967", "Phone - failed to verify / high risk"],
	["R968", "Phone - failed to verify / high risk"],
	["R998", "Identity - failed to verify / high risk"],
	["R999", "Identity - failed to verify / high risk"],
	["R355", "Identity - failed to verify / high risk"],
	["R401", "Device/IP - high risk"],
	["321", "Phone - failed to verify / high risk"],
	["510", "Identity - failed to verify / high risk"],
	["514", "Identity - failed to verify / high risk"],
	["539", "Address - failed to verify / high risk"],
	["636", "Address - failed to verify / high risk"],
	["637", "Identity - failed to verify / high risk"],
	["568", "Phone - failed to verify / high risk"],
	["572", "Phone - failed to verify / high risk"],
])

export const REASON_MESSAGE_TO_TOOLTIP = new Map([
	[
		"adverse media match",
		"The individual had a possible adverse media hit. The vendor conducted a web search based on the customer’s name and certain keywords such as “arrested” or “convicted”. Possible adverse media hits could include financial crimes, fraud, narcotics, sexual crimes, terrorism or violent crimes, amongst other things.",
	],
	[
		"fraud warning",
		"Both of the vendors have assigned a high risk fraud score to the applicant. Flags contributing to fraud score including things like application history, type of phone, age of email, email domain, IP location, etc.",
	],
	[
		"fraud risk",
		"One of the vendors has assigned a high risk fraud score to the applicant. Flags contributing to fraud score including things like application history, type of phone, age of email, email domain, IP location, etc.",
	],
	[
		"ofac or other watchlist",
		"There is a potential Office of Foreign Assets (OFAC) match. OFAC sanctions lists consist of individuals as well as countries or organizations that anyone in the US is not legally able to do business with.",
	],
	["multiple failed requests for documents", "The applicant has repeatedly provided invalid documents."],
	["altered/fictitious documents", "The applicant submitted a document that has been altered or a fake document."],
	[
		"previous activity on the unit platform",
		"Unit has previously identified that the applicant is associated with high risk potential",
	],
	["identity - failed to verify / high risk", "Vendor was unable to verify the full identity of the applicant."],
	["ssn - failed to verify / high risk", "Vendor was unable to verify the applicant’s SSN"],
	["dob - failed to verify / high risk", "Vendor was unable to verify the applicant’s date of birth"],
	[
		"address - failed to verify / high risk",
		"Vendor was unable to verify the applicant’s address or the address provided was determined to be undeliverable or a high risk address.",
	],
	[
		"phone - failed to verify / high risk",
		"The phone number provided was determined to be high risk. Reasons may include VoIP phone numbers, prepaid phone numbers, new phone numbers, inactive phone numbers, phones from a state where the customer has no address history, etc.",
	],
	[
		"name - failed to verify / high risk",
		"Vendor was unable to verify the applicant’s name or the applicant applied using a nickname/alias.",
	],
	[
		"email - high risk",
		"The email address provided was determined to be high risk. Reasons include high risk email domains, emails that appear unrelated to the applicant, new/inactive emails, etc.",
	],
	[
		"device/ip - high risk",
		"The device associated with the application was determined to be high risk. Reasons may include the same device being used for other unrelated applications, foreign devices, high fraud scores assigned to the device, IP address a significant distance from the physical address, etc.",
	],
	[
		"applicant on unit's internal denylist",
		"Unit maintains an internal denylist of individuals that are known bad actors on our platform or highly suspicious.",
	],
	[
		"suspicious connection to other applications",
		"Information from this application is linked to other unrelated applications that were submitted or this applicant is linked to other fraudulent applications on the Unit platform.",
	],
])

export type Recommendation = "VerificationRequired" | "Approve" | "Reject"

export interface FraudAssessment {
	assessmentScore: number
	recommendation: Recommendation
	details: string[]
}

export interface SharedElementsInsights {
	type: string
	attributes: {
		keySimilarities: string[]
		keyDifferences: string[]
		fraudAssessment: FraudAssessment
	}
}

export const getSharedElementsInsights = async (accessToken: string, applicationId: string) => {
	return await getResource<SharedElementsInsights>(
		`applications/${applicationId}/application-insights/SharedElements`,
		accessToken
	)
}

export type ApplicationRecommendation = "VerificationRequired" | "Approve" | "Reject"

export interface ManualReviewInsights {
	type: string
	attributes: {
		recommendation: ApplicationRecommendation
		applicationSummary: string
		reason: string
	}
}

export const getManualReviewInsights = async (accessToken: string, applicationId: string) => {
	return await getResource<ManualReviewInsights>(
		`applications/${applicationId}/application-insights/ManualReview`,
		accessToken
	)
}

export type FraudScore = "Low" | "Medium" | "High"

export interface WebsiteInsights {
	type: string
	attributes: {
		website_exists: boolean
		fraud_score: FraudScore
		business_vertical: string
		short_summary: string
		short_site_info: string
		website_domain_creation_date: string
		website_domain_registrar: string
	}
}

export const getWebsiteInsights = async (accessToken: string, applicationId: string) => {
	return await getResource<WebsiteInsights>(`applications/${applicationId}/application-insights/Website`, accessToken)
}
